import type { Unit } from '@/api/generated/models';

// unit.names je mapa jezik→naziv (npr. {en: 'Piece', de: 'Stück', hr: 'Komad'}) —
// razrješava se u trenutnom jeziku aplikacije pri ČITANJU, ne pri spremanju
// (isto obrazloženje kao FormWeekPickerInput/formatWeekYearRange ove sesije:
// referenca, ne kopija — novi jezik ili ispravak naziva odmah vrijedi posvuda).
export const unitLabel = (unit: Unit | undefined, language: string): string => {
  if (!unit) return '—';
  return unit.names?.[language] ?? unit.code ?? '—';
};

export const findUnitLabel = (
  units: Unit[] | undefined,
  unitId: string | undefined,
  language: string
): string =>
  unitLabel(
    units?.find((unit) => unit.id === unitId),
    language
  );

/**
 * Aktivne jedinice za dropdown kod unosa nove stavke. currentUnitId (opcionalno)
 * osigurava da se, kod uređivanja postojeće stavke čija je jedinica u
 * međuvremenu deaktivirana, ta jedinica ipak pojavi u listi — inače bi Select
 * prikazao prazno/nerazrješivo polje umjesto trenutno odabrane vrijednosti.
 */
export const activeUnitOptions = (
  units: Unit[] | undefined,
  language: string,
  currentUnitId?: string
) => {
  const list = units ?? [];
  const active = list.filter((unit) => unit.isActive || unit.id === currentUnitId);
  return active
    .map((unit) => ({ value: unit.id ?? '', label: unitLabel(unit, language) }))
    .filter((option) => option.value);
};
